<ng-container *transloco="let t; read: 'file-upload'">
  @if (uploader?.queue?.length === 0) {
    <div>
      <div
        ng2FileDrop
        class="file-upload__well"
        [ngClass]="{ 'nv-file-over': hasBaseDropZoneOver }"
        [uploader]="uploader"
        (fileOver)="fileOverBase($event)"
        (onFileDrop)="validateSelectedFiles($event)"
      >
        @if (size === 'normal') {
          <div class="file-upload__upload-icon">
            <xi-svg svg="plus"></xi-svg>
          </div>
        }
        <div class="file-upload__drag-and-drop-text">
          <p class="file-upload__drag-and-drop">{{ dragAndDropText }}</p>
          <p class="file-upload__or">{{ t('or') }}</p>
          <div class="file-upload__upload-button-container">
            <input
              type="file"
              name="file"
              id="dashboard-import-input"
              class="file-upload__upload_input"
              autofocus
              #fileInput
              ng2FileSelect
              (onFileSelected)="validateSelectedFiles($event, fileInput)"
              [uploader]="uploader"
              [accept]="allowedMIMETypes"
              appAutoFocus
            />
            <xi-default-button
              [text]="buttonText"
              [buttonSize]="buttonSize"
              [stretch]="true"
              (onClick)="fileInput.click()"
            ></xi-default-button>
          </div>

          <ng-container
            *ngTemplateOutlet="
              uploadNotesTpl;
              context: {
                $implicit:
                  uploadNotes?.length > 0
                    ? uploadNotes
                    : allowedExtensions[0] === 'json'
                      ? [t('only-json-allowed'), t('upload-help')]
                      : [],
              }
            "
          >
          </ng-container>

          <ng-template #uploadNotesTpl let-notes>
            @if (notes.length > 0) {
              <div>
                <div class="file-upload__horizontal-line"></div>

                <div class="file-upload__upload-notes">
                  @for (note of notes; track note) {
                    <p>{{ note }}</p>
                  }
                </div>
              </div>
            }
          </ng-template>
        </div>
      </div>
    </div>
  }

  @if (filesToConfirm.length > 0 && !lastErrorMessage && importedItemDto && requiresConfirmation) {
    <div class="file-upload__uploaded">
      <div class="file-upload__well">
        @if (size === 'normal') {
          <div class="file-upload__uploaded-icon">
            <xi-svg svg="yes"></xi-svg>
          </div>
        }
        <p class="file-upload__uploaded-text">{{ t('file-uploaded') }}</p>
        @for (item of filesToConfirm; track item) {
          <p class="file-upload__uploaded-queue">
            {{ item?.file?.name }}
          </p>
        }
        <div class="file-upload__horizontal-line"></div>
      </div>
    </div>
  } @else if (uploader?.queue?.length > 0 && !lastErrorMessage) {
    <div class="file-upload__uploading">
      <div class="file-upload__upload-progress-label">{{ t('uploading') }}</div>
      <table class="file-upload__uploading-table">
        <tbody>
          @for (item of uploader.queue; track item) {
            <tr>
              <td>
                @if (progressIndicator === 'spinner') {
                  <div class="file-upload__upload-progress-spinner">
                    <mat-progress-spinner
                      class="margin-auto-0"
                      color="primary"
                      [diameter]="293 * sizeMultipliers[size]"
                      [strokeWidth]="10 * sizeMultipliers[size]"
                      mode="determinate"
                      [value]="item.progress"
                    ></mat-progress-spinner>
                  </div>
                }
                @if (progressIndicator === 'bar') {
                  <div class="file-upload__upload-progress-bar">
                    <mat-progress-bar color="primary" mode="determinate" [value]="item.progress">
                    </mat-progress-bar>
                  </div>
                }
                <div class="file-upload__upload-file-name">{{ item?.file?.name }}</div>
                <div class="file-upload__upload-file-info">
                  {{ item?.file?.size | bytes }}
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
  @if (lastErrorMessage && notificationType === 'paragraph') {
    <p class="file-upload__upload-error">
      {{ lastErrorMessage }}
    </p>
  }
</ng-container>
